/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import Link from "next/link";
import axios from "axios";
import { useRouter } from "next/router";

import styles from "@/styles/homepage/Home.module.css";

import HamburgerMenu from "@/components/home/HamburgerMenu";
import PublicFooter from "@/components/publicProfiles/Footer/PublicFooter";
import SquareCheckbox from "@/components/shared/inputs/SquareCheckbox";
import { useAlertContext } from "@/context/AlertContext";
import AlertHandler from "@/helpers/AlertHandler";
import Alert from "@/components/shared/Alerts/Alert";

export default function SupportPage() {
  const { isAlertOpen, setAlertComponent } = useAlertContext();

  const [name, setName] = useState<string>("");
  const [uid, setUid] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [platform, setPlatform] = useState<"IOS" | "Android">();
  const [version, setVersion] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const router = useRouter();

  useEffect(() => {
    const { uid, version } = router.query;
    if (uid) {
      setUid(uid as string);
    }
    if (version) {
      setVersion(version as string);
    }
  }, [router.query]);

  function displayNav() {
    const nav = document.getElementById("nav");
    const hamburger = document.getElementById("hamburger");
    if (nav) {
      if (nav.style.height === "170px") {
        nav.style.height = "0";
        nav.style.padding = "0";
      } else {
        nav.style.height = "170px";
        nav.style.padding = "2% 0";
      }
    }

    if (hamburger) {
      if (hamburger.style.backgroundColor !== "gray") {
        hamburger.style.backgroundColor = "gray";
        hamburger.style.backgroundImage = "none";
      } else {
        hamburger.style.backgroundColor = "";
      }
    }
  }

  function handleSubmit() {
    if (name === "" || uid === "" || description === "" || !platform) {
      setAlertComponent(
        <Alert
          type="warning"
          elementName="Alert"
          message="All fields are required."
        />,
        5000
      );
      return;
    }

    let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!regex.test(email)) {
      setAlertComponent(
        <Alert
          type="warning"
          elementName="Alert"
          message="Please enter a valid email address."
        />,
        5000
      );
      return;
    }

    const inputData = {
      name: name,
      uid: uid,
      email: email,
      description: description,
      platform: platform,
      version: version,
    };

    console.log("Support data: ", inputData);

    const options = {
      method: "POST",
      data: inputData,
      url: "https://www.dimensional.me/api/hello",
    };

    setSuccess(true);
    axios(options)
      .then((res) => {
        console.log(res);
        console.log("Successfully sent support data");
      })
      .catch((err) => {
        setSuccess(false);
        console.log("Error sending data", err);
      });
  }

  return (
    <>
      {isAlertOpen && <AlertHandler />}
      <div className={styles.mobileNavParent}>
        <div className={styles.mobileLogoParent}>
          <Link href={"/"}>
            <img
              src="https://global-uploads.webflow.com/5ddd2caed93ad8355b40f958/62656cd5e8ee77d13eec117d_dimensional-logo.png"
              loading="lazy"
              width="100"
              alt="Dimensional"
            />
          </Link>
        </div>
        <div
          className={styles.hamburger}
          id="hamburger"
          onClick={(e) => {
            displayNav();
          }}
        >
          <HamburgerMenu />
        </div>
      </div>

      <nav id="nav" className={styles.nav}>
        <div className={styles.navParent}>
          <div className={styles.navLeft}>
            <div className={styles.logoParent}>
              <Link href={"/"}>
                <img
                  src="https://global-uploads.webflow.com/5ddd2caed93ad8355b40f958/62656cd5e8ee77d13eec117d_dimensional-logo.png"
                  loading="lazy"
                  width="100"
                  alt="Dimensional"
                />
              </Link>
            </div>
          </div>
          <div className={styles.navRightParent}>
            <div className={`${styles.navChild} ${styles.firstNav}`}>
              <Link href={"/"}>Home</Link>
            </div>
            <div className={styles.navChild}>
              <a href="https://about.dimensional.me/blog">Blog</a>
            </div>
            <div className={styles.navChild}>
              <a href="https://about.dimensional.me/about">About</a>
            </div>
          </div>
        </div>
      </nav>

      <div className={styles.supportMain}>
        {success === false && (
          <>
            <h1 className={styles.supportHeader}>Support</h1>
            <h3 className={styles.supportSubTitle}>
              {
                "Having issues with Dimensional? Let us know and we'll get back to you as soon as we can."
              }
            </h3>
            <h3
              style={{ marginTop: "-15px", opacity: "0.5", fontSize: "16px" }}
              className={styles.supportSubTitle}
            >
              We will not respond to rude messages or harassment.
            </h3>
            <label className={styles.supportLabel}>Full Name</label>
            <input
              onChange={(e) => setName(e.target.value)}
              className={styles.supportInput}
            />
            <label className={styles.supportLabel}>
              UID (this is at the bottom of the Settings tab)
            </label>
            <input
              onChange={(e) => setUid(e.target.value)}
              className={styles.supportInput}
              value={uid}
            />
            <label className={styles.supportLabel}>Email Address</label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              className={styles.supportInput}
            />
            <label className={styles.supportLabel}>Platform</label>
            <div className={styles.supportCheckParent}>
              <div className={styles.supportCheckBoxWrapper}>
                <p className={styles.supportCheckLabel}>IOS</p>
                <SquareCheckbox
                  setValue={(e) => {
                    setPlatform("IOS");
                  }}
                  currentValue={platform === "IOS"}
                />
              </div>
              <div
                style={{ marginLeft: "15px" }}
                className={styles.supportCheckBoxWrapper}
              >
                <p className={styles.supportCheckLabel}>Android</p>
                <SquareCheckbox
                  setValue={(e) => {
                    setPlatform("Android");
                  }}
                  currentValue={platform === "Android"}
                />
              </div>
            </div>
            <label className={styles.supportLabel}>How can we help you?</label>
            <textarea
              onChange={(e) => setDescription(e.target.value)}
              className={styles.supportTextArea}
            ></textarea>
            <button
              onClick={() => handleSubmit()}
              className={styles.supportSubmit}
            >
              Submit
            </button>{" "}
          </>
        )}
        {success === true && (
          <>
            <h1 className={styles.supportHeader}>Support</h1>
            <h3 className={styles.supportSubTitle}>
              {
                "Having issues with Dimensional? Let us know and we'll get back to you as soon as we can."
              }
            </h3>
            <h4 className={styles.supportSuccessMessage}>
              {
                "We've created a support ticket and will reach out to you at the email provided."
              }
            </h4>
          </>
        )}
      </div>
      <PublicFooter />
    </>
  );
}
